<div class="relative z-10 flex h-full w-full max-w-full min-w-0 flex-col overflow-hidden bg-white shadow-2xl">
  <div class="flex shrink-0 items-start justify-between gap-2 border-b border-gray-100 px-[16px] py-[12px]">
    <div class="min-w-0 flex-1">
      <div class="text-[10px] font-semibold uppercase tracking-wider text-gray-400">
        {{ 'board_v3_board_settings' | translate }}
      </div>
      <div class="text-base font-bold text-gray-900">{{ 'board_v3_card_view_title' | translate }}</div>
      <div class="mt-0.5 text-xs text-gray-500">
        {{ 'board_v3_card_view_hint' | translate }}
      </div>
    </div>
  </div>

  <div class="crm-scroll min-h-0 flex-1 overflow-x-hidden overflow-y-auto px-[16px] py-[12px] w-full">
    <div class="mb-1.5 text-[10px] font-semibold uppercase tracking-wider text-gray-400">
      {{ 'board_v3_preview' | translate }}
    </div>
    <div class="w-full overflow-hidden rounded-xl bg-gradient-to-b from-gray-100 to-gray-50 p-[12px] ring-1 ring-gray-100">
      <app-board-v3-card-item [compact]="true" [card]="previewCard" [viewFields]="previewViewFields" [allFields]="allFields" />
    </div>

    <div class="mt-[16px] flex items-center justify-between">
      <div class="text-[10px] font-semibold uppercase tracking-wider text-gray-400">
        {{ 'board_v3_visible_fields' | translate }}
      </div>
      <div class="text-xs text-gray-400">{{ enabledCount }}/{{ totalCount }}</div>
    </div>

    <div class="mt-2 flex flex-col gap-1.5">
      @for (field of allFields; track fieldKey(field)) {
        <div class="flex w-full min-w-0 items-center gap-2 rounded-lg bg-white px-[12px] py-[8px] ring-1 ring-gray-100">
          <app-icon class="!text-[18px] !h-[18px] !w-[18px] !leading-none shrink-0 text-gray-500">{{ field.icon || 'tune' }}</app-icon>
          <span class="min-w-0 flex-1 truncate text-sm text-gray-800">{{ field.is_system ? (field.name | translate) : field.name }}</span>
          <p-toggleswitch
            class="shrink-0"
            [ngModel]="isEnabled(field)"
            (ngModelChange)="setEnabled(field, $event)"
          />
        </div>
      }

      @if (allFields.length === 0) {
        <div class="rounded-lg bg-gray-50 px-[12px] py-[16px] text-center text-sm text-gray-400">
          {{ 'board_v3_no_fields_to_display' | translate }}
        </div>
      }
    </div>
  </div>

  <div class="flex gap-2 border-t border-gray-100 justify-center py-[12px] w-full">
    <app-button [btnType]="'cancel'" (onChangeClick)="onClose()">
      {{ 'cancel' | translate }}
    </app-button>
    <app-button [disabled]="isSaving" (onChangeClick)="onApplyClick()">
      {{ (isSaving ? 'saving' : 'apply') | translate }}
    </app-button>
  </div>
  @if (errorMessage) {
    <div class="border-t border-red-100 bg-red-50 px-[16px] py-[8px] text-xs text-red-600">
      {{ errorMessage }}
    </div>
  }
</div>
